'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { CategoryPathProps } from '~types/index'
import parseForHybrid from './parseForHybrid'

export default async function goToCategory(
  router: AppRouterInstance,
  category: CategoryPathProps
) {
  const { push } = router
  const parsedCategory = parseForHybrid(category)
  push(parsedCategory)
}
